import { Box, Card, CardContent, Typography } from "@mui/material";
import { KPICardProps } from "./interface";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";

export const KPICard: React.FC<KPICardProps> = ({
  title,
  value,
  icon,
  trend,
  color,
  unit = "",
}) => {
  return (
    <Card
      sx={{
        background: `linear-gradient(135deg, ${color}15 0%, ${color}05 100%)`,
        border: `2px solid ${color}30`,
        borderRadius: 3,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        zIndex: 1,
        transition: "all 0.2s ease",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: `0 4px 16px ${color}20`,
          border: `2px solid ${color}50`,
          zIndex: 2,
        },
      }}
    >
      <CardContent sx={{ flex: 1 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            height: "100%",
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ fontWeight: 600, display: "block", mb: 0.5, fontSize: "0.85rem" }}
            >
              {title}
            </Typography>
            <Box
              sx={{ display: "flex", alignItems: "baseline", gap: 0.5, mt: 1 }}
            >
              <Typography variant="h4" sx={{ fontWeight: 700, color, fontSize: "1.5rem" }}>
                {typeof value === "number" ? value.toLocaleString() : value}
              </Typography>
              {unit && (
                <Typography variant="caption" color="text.secondary">
                  {unit}
                </Typography>
              )}
            </Box>
            {trend !== undefined && (
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 1 }}
              >
                {trend > 0 ? (
                  <TrendingUpIcon sx={{ fontSize: 14, color: "#4CAF50" }} />
                ) : trend < 0 ? (
                  <TrendingDownIcon sx={{ fontSize: 14, color: "#F44336" }} />
                ) : null}
                <Typography
                  variant="caption"
                  color={
                    trend > 0
                      ? "#4CAF50"
                      : trend < 0
                      ? "#F44336"
                      : "text.secondary"
                  }
                  sx={{ fontSize: "0.7rem" }}
                >
                  {trend === 0 ? "No change" : `${Math.abs(trend)}%`}
                </Typography>
              </Box>
            )}
          </Box>
          <Box
            sx={{
              p: 1.5,
              borderRadius: 2,
              backgroundColor: `${color}20`,
              color: color,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minWidth: 48,
              minHeight: 48,
            }}
          >
            {icon}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};
